import React from 'react';
import Header from '../../components/Header';
import AboutUsBody from '../../components/AboutUs/AboutUsBody';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className="aboutus-black-back">
      <Header PageName="about us" fTitle="about" sTitle="us" />
      <AboutUsBody />
    </div>
  );
};

export default AboutUs;
